import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { CountButton } from 'page/StartScreen/combine/CountButton'
import { ItemsLine } from 'page/StartScreen/combine/item/ItemsLine'
import { ItemsNone } from 'page/StartScreen/combine/item/ItemsNone'
import { MainCard } from 'page/StartScreen/combine/item/MainCard'
import { PricesButton } from 'page/StartScreen/combine/price/PricesButton'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const CombineStep = observer(() => {
  const item = store.tempComboItem || store.item!
  const { init, line, items } = item.rec
  const count = items.length
  const brands = item.rec.brands.length > 1
  const colors = item.rec.colors.length > 1
  const categories = item.rec.categories.length > 1
  const prices = opt.prices
  const brands_count = item.rec.brand.value.size
  const colors_count = item.rec.color.value.size
  const categories_count = item.rec.category.value.size
  const filters = brands || colors || categories || prices

  const onBrand = useLatestCallback(async () => {
    item.step = 'brand'
  })

  const onColor = useLatestCallback(async () => {
    item.step = 'color'
  })

  const onCategory = useLatestCallback(async () => {
    item.step = 'category'
  })

  const onClearBrand = useLatestCallback(async () => {
    item.clearBrand()
  })

  const onClearColor = useLatestCallback(async () => {
    item.clearColor()
  })

  const onClearCategory = useLatestCallback(async () => {
    item.clearCategory()
  })

  return (
    <Vertical gap={16} oh>
      <MainCard item={item.json} />
      <Typo size={13} nowrap>
        {i18n('AdditionalItems')} ({count})
      </Typo>
      {init && filters && (
        <Space gap={12} wrap>
          {brands && (
            <CountButton
              title={i18n('Brand')}
              count={brands_count}
              onClick={onBrand}
              onClear={onClearBrand}
            />
          )}
          {colors && (
            <CountButton
              title={i18n('Color')}
              count={colors_count}
              onClick={onColor}
              onClear={onClearColor}
            />
          )}
          {categories && (
            <CountButton
              title={i18n('Category')}
              count={categories_count}
              onClick={onCategory}
              onClear={onClearCategory}
            />
          )}
          {prices && <PricesButton />}
        </Space>
      )}
      <Vertical gap={12} flex="1 1 0" tall>
        {!line && <ItemsNone />}
        {line && <ItemsLine />}
      </Vertical>
    </Vertical>
  )
})
